// extracted by mini-css-extract-plugin
module.exports = {"pagination":"page_nation-module--pagination--3lu7J","dots":"page_nation-module--dots--3P_SI","active":"page_nation-module--active--2CzGA"};